module.exports = __webpack_public_path__ + "fonts/700-italic-greek-ext.a889976.woff2";